import type { PartnerBusiness } from '../types';
import { getListingValidUntil } from './listingPeriod';

export function isListingPeriodActive(business: PartnerBusiness): boolean {
  const until = getListingValidUntil(business);
  if (!until) return business.status === 'active';
  return until.getTime() > Date.now();
}

export function isSubscriptionCancelled(business: PartnerBusiness): boolean {
  return business.subscriptionStatus === 'cancelled';
}

export function canCancelSubscription(business: PartnerBusiness): boolean {
  return (
    business.status === 'active' &&
    !isSubscriptionCancelled(business) &&
    isListingPeriodActive(business)
  );
}

export function isPartnerListingLive(business: PartnerBusiness): boolean {
  return business.status === 'active' && isListingPeriodActive(business);
}

/** Move to expired when the paid period has ended. */
export function normalizeBusinessSubscription(business: PartnerBusiness): PartnerBusiness {
  if (business.status !== 'active') return business;
  if (!isListingPeriodActive(business)) {
    return { ...business, status: 'expired', updatedAt: new Date().toISOString() };
  }
  return business;
}
